<template>
  <div>
    <datatable
      title="Admin Education Degrees"
      @delete="deleteEducationDegree"
      @create="createEducationDegree"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-education-degrees',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'name',
          value: 'name'
        }
      ],
      data: [],
      operations: [],
      chosen_text: {}
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllEducationDegrees().then(response => {
        this.data = response
      })
    },
    deleteEducationDegree (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.name,
        item_name: delete_data.name,
        method: 'deleteEducationDegree',
        method_params: { id: delete_data.id }
      })
    },
    createEducationDegree () {
      this.create({ designator: 'admin-education-degrees-form-modal', component_name: 'AdminEducationDegreesForm', is_create: true, modal_title: 'Create new Education Degree' })
    },
    editClick (data) {
      this.create({ designator: 'admin-education-degrees-form-modal', component_name: 'AdminEducationDegreesForm', data, modal_title: data.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
